export default __webpack_public_path__ + "static/media/blog-img218.706e015f.jpg";